// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reject-reason-select-dropdown .MuiOutlinedInput-root {
    height: 31px !important
}

.reject-reason-text-field .MuiOutlinedInput-root {
    /* height: 35px !important */
    padding: 8px 12px;
}`, "",{"version":3,"sources":["webpack://./src/pages/OrgHistory/components/ReusableDataGrid/SyncUsersConfirmationModal/SyncUsersConfirmationModal.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;AACrB","sourcesContent":[".reject-reason-select-dropdown .MuiOutlinedInput-root {\n    height: 31px !important\n}\n\n.reject-reason-text-field .MuiOutlinedInput-root {\n    /* height: 35px !important */\n    padding: 8px 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
